module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (185).ebc53588.jpg";